module.exports = __webpack_public_path__ + "assets/media/help-prize.b7b27da4.svg";